






























































import { Component, Prop, Vue } from "vue-property-decorator";
import { relationStudentReleaseApi } from "@/api/teacherManage";
@Component({
  components: {},
})
export default class extends Vue {
  @Prop() studentInfo!: any;
  dialogTableVisible = false;
  num: number = 3;
  detailInfo = [];
  searchInfo = {
    remarks: "",
  };
  rules = {
    remarks: [{ required: true, message: "请填写备注信息", trigger: "blur" }],
  };
  showDialog() {
    this.searchInfo.remarks = "";
    this.dialogTableVisible = true;
  }
  handleCancel() {
    this.dialogTableVisible = false;
  }
  handleConfirm() {
    (this.$refs["form"] as Vue & { validate: Function }).validate(
      (valid: boolean) => {
        if (valid) {
          relationStudentReleaseApi({
            relation_id: this.studentInfo.relation_id,
            remark: this.searchInfo.remarks,
          }).then((res: any) => {
            if (res.error_code === 0) {
              this.$message({
                type: "success",
                message: "关联已解除",
              });
              this.dialogTableVisible = false;
              this.$emit("changeRelease");
            }
          });
        }
      }
    );
  }
}
